import React from "react";
import { Card, KeyValueList, ValueOrPlaceholder } from "@sscs/ui";
import styles from "./cryptoAsset.module.scss";
// https://cyclonedx.org/docs/1.6/json/#components_items_cryptoProperties_algorithmProperties_mode
const MODE_TO_TEXT = {
    cbc: "Cipher block chaining",
    ecb: "Electronic codebook",
    ccm: "Counter with cipher block chaining message authentication code",
    gcm: "Galois/counter",
    cfb: "Cipher feedback",
    ofb: "Output feedback",
    ctr: "Counter",
    unknown: "Unknown",
};
// https://cyclonedx.org/docs/1.6/json/#components_items_cryptoProperties_algorithmProperties_primitive
const PRIMITIVE_TO_TEXT = {
    drbg: "Deterministic random bit generator (DRBG)",
    mac: "Message authentication code (MAC)",
    "block-cipher": "Block cipher",
    "stream-cipher": "Stream cipher",
    signature: "Signature",
    hash: "Hash function",
    pke: "Public key encryption (PKE)",
    xof: "Extendable output function (XOF)",
    kdf: "Key derivation function (KDF)",
    "key-agree": "Key-agreement protocol",
    kem: "Key encapsulation mechanism (KEM)",
    ae: "Authenticated encryption (AE)",
    combiner: "Combiner",
    unknown: "Unknown",
};
const Summary = ({ algorithm }) => {
    return (React.createElement("div", null,
        PRIMITIVE_TO_TEXT[algorithm.primitive],
        " ",
        React.createElement("small", { className: styles["secondary-text"] },
            "(Set identifier:",
            " ",
            algorithm.size ? (`${algorithm.size} bits`) : (React.createElement(ValueOrPlaceholder, { value: undefined })),
            ")"),
        React.createElement("div", { className: styles["secondary-text"] },
            "Cryptographic functions:",
            " ",
            React.createElement(ValueOrPlaceholder, { value: algorithm.functions.join(", ") }))));
};
const Details = ({ algorithm }) => {
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, null, "Algorithm details"),
        React.createElement(Card.Content, null,
            React.createElement(KeyValueList, { list: {
                    Algorithm: algorithm.type,
                    Mode: MODE_TO_TEXT[algorithm.mode],
                    Primitive: PRIMITIVE_TO_TEXT[algorithm.primitive],
                    "Quantum security level": (React.createElement(ValueOrPlaceholder, { value: algorithm.pqc_level })),
                    "Cryptographic functions": algorithm.functions.length > 0 ? (React.createElement(React.Fragment, null, algorithm.functions.map((item) => (React.createElement("div", { key: item }, item))))) : (React.createElement(ValueOrPlaceholder, { value: "" })),
                    "Set identifier": React.createElement(ValueOrPlaceholder, { value: algorithm.size }),
                    ...Object.fromEntries(algorithm.properties),
                } }))));
};
export default { Details, Summary };
//# sourceMappingURL=Algorithm.js.map